import React, {Component} from 'react';
import './App.css';
import LoginComponent from './LoginComponent/Login';
import GetUserNameComponent from './LoginComponent/StudentGetUserName';
import ResetPasswordComponent from './LoginComponent/StudentResetPassword';
import AboutComponent from './AboutComponent/About';
import MainComponent from './MainComponent/Main';
import MainTeacherComponent from './TeachersComponent/Main';
import ResourcesComponent from './ResourcesComponent/Resources';
import StudentsComponent from './TeachersComponent/Students';
import SchoolAdminComponent from './AdminComponent/SchoolAdmin';
import SchoolAdminManagementComponent from './AdminComponent/SchoolAdminManagement';
import SchoolManagementComponent from './AdminComponent/SchoolManagement';
import ParentComponent from './ParentComponent/Parent';
import ContentComponent from './ContentComponent/Content';
import KSContent from "./ContentComponent/KidSpeak";
import MainStudentComponent from './StudentsComponent/Main';
import NeedsAssessmentComponent from './NeedsAssessmentComponent/NeedsAssessment';
import {BrowserRouter as Router, Route, Switch} from 'react-router-dom';
import RequestAccountComponent from './RequestAccountComponent/RequestAccount';
import HelpComponent from './HelpComponent/Help';
import configureStore from "./Shared/configureStore";
import { PersistGate } from 'redux-persist/integration/react';
import {Provider} from 'react-redux';

class App extends Component {

    constructor(props) {
        super(props);

        let {store, persistor} = configureStore();

        this.state = {
            user: {},
            student: {},
            classId: 0,
            store: store,
            persistor: persistor,
        };
    }

    setUser = (user) => {
        this.setState({user: user});

    };

    handleStudentClick = (student, classId) => {
        this.setState({student: student, classId: classId});
    };

    handleAddStudent = (classId) => {
        this.setState({classId: classId});
    };

    render() {
        return (
            <Provider store={this.state.store}>
                <PersistGate persistor={this.state.persistor}>
                    <Router>
                        <Switch>
                            <Route path="/" exact render={props =>
                                <MainComponent persistor={this.state.persistor} {...props} userCallback={this.setUser}/>
                            }/>
                            <Route path="/login" exact render={props =>
                                <LoginComponent {...props} callback={this.setUser}/>
                            }/>
                            <Route path="/get-username" exact render={props =>
                                <GetUserNameComponent {...props} callback={this.setUser}/>
                            }/>
                            <Route path="/reset-password" exact render={props =>
                                <ResetPasswordComponent {...props} callback={this.setUser}/>
                            }/>
                            <Route path="/about" exact render={props =>
                                <AboutComponent {...props} callback={this.setUser}/>
                            }/>
                            <Route path="/resources" exact render={props =>
                                   <ResourcesComponent persistor={this.state.persistor} {...props} callback={this.setUser}/>
                            }/>
                            <Route path="/request-account" exact component={RequestAccountComponent}/>
                            <Route path="/help" exact component={HelpComponent}/>
                            <Route path="/teacher" exact render={props =>
                                <MainTeacherComponent persistor={this.state.persistor} strict={true} {...props}
                                                      handleAddStudent={this.handleAddStudent}
                                                      handleStudentClick={this.handleStudentClick}
                                                      callback={this.setUser}
                                                      user={this.state.user}/>
                            }/>
                            <Route path="/teacher/student" exact render={props =>
                                <StudentsComponent {...props} edit={true} student={this.state.student}
                                                   classId={this.state.classId}/>
                            }/>
                            <Route path="/teacher/add-student" exact render={props =>
                                <StudentsComponent {...props} edit={false} classId={this.state.classId}/>
                            }/>
                            <Route path="/student" exact render={props =>
                                <MainStudentComponent persistor={this.state.persistor} role={"student"} {...props} />
                            }/>
                            <Route path="/parent" exact render={props =>
                                <ParentComponent persistor={this.state.persistor} {...props} />
                            }/>
                            <Route path="/school-admin" exact render={props =>
                                <SchoolAdminComponent persistor={this.state.persistor} strict={true} {...props}
                                                      handleAddStudent={this.handleAddStudent}
                                                      handleStudentClick={this.handleStudentClick}
                                                      callback={this.setUser}
                                                      user={this.state.user}/>
                            }/>
                            <Route path="/content" exact render={props =>
                                <ContentComponent {...props} />
                            }/>
                            <Route path="/admin" exact render={props =>
                                <SchoolAdminManagementComponent {...props} />
                            }/>
                            <Route path="/schools" exact render={props =>
                                <SchoolManagementComponent {...props} />
                            }/>
                            <Route path="/content/kidspeak" exact render={props =>
                                <KSContent persistor={this.state.persistor} {...props} />
                            }/>
                            <Route path="/needs-assessment" exact render={props =>
                                <NeedsAssessmentComponent {...props} />
                            }/>
                            <Route component={NoMatch}/>
                        </Switch>
                    </Router>
                </PersistGate>
            </Provider>
        );
    }
}

const NoMatch = ({location}) => (
    <div>
        <h3>
            No match for <code>{location.pathname}</code>
        </h3>
    </div>
);

export default App;
